export var LSAPIKnownErrorCode;
(function (LSAPIKnownErrorCode) {
    LSAPIKnownErrorCode["NOT_FOUND"] = "NOT_FOUND";
    LSAPIKnownErrorCode["INVALID_CREDENTIALS"] = "INVALID_CREDENTIALS";
    LSAPIKnownErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    LSAPIKnownErrorCode["FUNDS_ON_HOLD"] = "FUNDS_ON_HOLD_ERROR";
    LSAPIKnownErrorCode["COINBASE_AUTHORIZATION_LIMIT_EXCEEDED"] = "COINBASE_AUTHORIZATION_LIMIT_EXCEEDED";
    LSAPIKnownErrorCode["COINBASE_INVALID_2FA"] = "COINBASE_INVALID_2FA";
    LSAPIKnownErrorCode["ACTIVE_SWAP_LIMIT_EXCEEDED"] = "ACTIVE_SWAP_LIMIT_EXCEEDED";
    LSAPIKnownErrorCode["NETWORK_ACCOUNT_ALREADY_EXISTS"] = "NETWORK_ACCOUNT_ALREADY_EXISTS";
    LSAPIKnownErrorCode["BLACKLISTED_ADDRESS"] = "BLACKLISTED_ADDRESS";
    LSAPIKnownErrorCode["INVALID_ADDRESS_ERROR"] = "INVALID_ADDRESS_ERROR";
    LSAPIKnownErrorCode["UNACTIVATED_ADDRESS_ERROR"] = "UNACTIVATED_ADDRESS_ERROR";
    LSAPIKnownErrorCode["NETWORK_CURRENCY_DAILY_LIMIT_REACHED"] = "NETWORK_CURRENCY_DAILY_LIMIT_REACHED";
    LSAPIKnownErrorCode["ROUTE_NOT_FOUND_ERROR"] = "ROUTE_NOT_FOUND_ERROR";
    LSAPIKnownErrorCode["PRICE_IMPACT_TOO_HIGH"] = "PRICE_IMPACT_TOO_HIGH";
})(LSAPIKnownErrorCode || (LSAPIKnownErrorCode = {}));
